import React, { Component } from "react";
import { connect } from "react-redux";
import { CurrBinNo, TOBPMainWrapper } from "./TOBPMain.style";
import TMLoader from "../../../../components/Loader/Loader";
import UserGreeting from "../../../../components/UserGreeting/UserGreeting";
import TitleWrapper from "../../../../components/TitleWrap/TitleWrap";
import RackSearch from "./RackSearch/RackSearch";
import { Divider, message } from "antd";
import {
  getTaskIDThunk,
  getTaskIDDetailsThunk,
  fetchBinItemsThunk,
} from "../../../../redux/TOThunks/Action";
import DonePicking from "./DonePicking/DonePicking";
import { TaskIdCheck } from "../../components/TaskIdCheck/TaskIdCheck";
import OfflinePage from "../../../OfflinePage/OfflinePage";
import TOTaskDetails from "./TOTaskDetails/TOTaskDetails";
export class TOBPMain extends Component {
  state = {
    pageLoading: false,
    pickingDoneModal: false,
    showDonePicking: false,
    selectedBin: null,
  };

  componentDidMount = () => {
    localStorage.removeItem("selectedBin");
    if (this.props.access_token) {
      this.pageLoadCall();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.isOnline !== this.props.isOnline && this.props.isOnline) {
      this.pageLoadCall();
    }
  };

  pageLoadCall = () => {
    if (!localStorage.getItem("taskId")) {
      this.getTaskId();
    } else {
      this.getTaskIdDetails();
    }
  };

  pageLoadingToggle = (value) => {
    this.setState({
      pageLoading: value,
    });
  };

  getTaskId = () => {
    this.setState({
      pageLoading: true,
    });
    this.props
      .getTaskIDThunk({
        access_token: this.props.access_token,
      })
      .then(() => {
        this.setState({
          pageLoading: false,
        });
        if (this.props.TOReducer?.TaskIdErr) {
          message.error(this.props.TOReducer?.TaskIdErr, 10);
        } else if (this.props.TOReducer?.TaskIdData?.taskId) {
          localStorage.setItem(
            "taskId",
            this.props.TOReducer?.TaskIdData?.taskId
          );
          this.getTaskIdDetails();
        }
      });
  };

  getTaskIdDetails = () => {
    this.setState({
      pageLoading: true,
    });

    if (TaskIdCheck) {
      this.props
        .getTaskIDDetailsThunk({
          access_token: this.props.access_token,
          taskId: localStorage.getItem("taskId"),
        })
        .then(() => {
          this.setState({
            pageLoading: false,
          });
          if (this.props.TOReducer?.TaskIdDetailsErr) {
            message.error(this.props.TOReducer?.TaskIdDetailsErr);
            this.setState({
              showDonePicking: false,
            });
          } else if (this.props.TOReducer?.TaskIdDetailsData) {
            this.setState({
              showDonePicking: this.props.TOReducer?.TaskIdDetailsData?.length
                ? true
                : false,
            });
          }
        });
    }
  };

  render() {
    let { pageLoading, showDonePicking, selectedBin } = this.state;

    return (
      <>
        {this.props.isOnline ? (
          <TOBPMainWrapper>
            {pageLoading ? <TMLoader /> : null}

            <div style={{ width: "100%" }}>
              <UserGreeting />
              <br />
              <br />

              <div className="flexDiv">
                <TitleWrapper title={"TO Bin Picker"} />

                <CurrBinNo>
                  Task ID# <span>{localStorage.getItem("taskId")}</span>
                </CurrBinNo>
              </div>

              <p className="selected">
                Selected Bin :{" "}
                <span>{this.state.selectedBin?.value ?? "-"}</span>
              </p>

              <div className="rackSearch">
                <RackSearch
                  isPick
                  disableSelect={!localStorage.getItem("taskId")}
                  updateSelectedBin={(e) => this.setState({ selectedBin: e })}
                  redirect="to-bin-picker-scan"
                  onScanHandler={(e) => {
                    let data = {
                      value: e,
                      label: e,
                    };
                    this.setState({ selectedBin: data });
                  }}
                />
                <button
                  className="bbtn"
                  onClick={() => this.props.history.push("/to-bin-picking")}
                  disabled={
                    !localStorage.getItem("taskId") ||
                    !localStorage.getItem("selectedBin") ||
                    !selectedBin
                  }
                >
                  Submit
                </button>
              </div>
            </div>

            {showDonePicking ? (
              <>
                <Divider>Or</Divider>
                <TOTaskDetails
                  data={this.props.TOReducer?.TaskIdDetailsData}
                  apiCall={() => this.getTaskIdDetails()}
                />
                <DonePicking
                  history={this.props.history}
                  getTaskId={() => this.getTaskId()}
                  loading={() => this.pageLoadingToggle()}
                />
              </>
            ) : null}
          </TOBPMainWrapper>
        ) : (
          <OfflinePage />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = {
  getTaskIDThunk,
  getTaskIDDetailsThunk,
  fetchBinItemsThunk,
};

export default connect(mapStateToProps, mapDispatchToProps)(TOBPMain);
